/**
 * Possible statuses for applications in the platform
 * Used to track the lifecycle of an app from upload to production
 */
export const AppStatus = {
  AWAITING_UPLOAD: 'awaiting_upload',
  ANALYZING_APK: 'analyzing_apk',
  DEPLOYMENT_STARTED: 'deployment_started',
  INTERNAL_TESTING: 'internal_testing',
  CLOSED_TESTING: 'closed_testing',
  PRODUCTION_RELEASE: 'production_release',
  APP_LIVE: 'app_live',
};

/**
 * Additional information for each status
 * Used for UI display and business logic
 */
export const AppStatusInfo = {
  [AppStatus.AWAITING_UPLOAD]: {
    displayName: 'Awaiting Upload',
    color: 'gray',
    progressPercent: 3,
    step: 1,
    description: 'Waiting for AAB upload'
  },
  [AppStatus.ANALYZING_APK]: {
    displayName: 'Analyzing App',
    color: 'blue',
    progressPercent: 10,
    step: 2,
    description: 'Analyzing your app'
  },
  [AppStatus.DEPLOYMENT_STARTED]: {
    displayName: 'Deployment Started',
    color: 'purple',
    progressPercent: 20,
    step: 3,
    description: 'Deployment in progress'
  },
  [AppStatus.INTERNAL_TESTING]: {
    displayName: 'Internal Testing',
    color: 'orange',
    progressPercent: 35,
    step: 4,
    description: 'Testing with internal team'
  },
  [AppStatus.CLOSED_TESTING]: {
    displayName: 'Closed Testing',
    color: 'amber',
    progressPercent: 60,
    step: 5,
    description: 'Testing with closed group'
  },
  [AppStatus.PRODUCTION_RELEASE]: {
    displayName: 'Production Release',
    color: 'green',
    progressPercent: 80,
    step: 6,
    description: 'App submitted to store'
  },
  [AppStatus.APP_LIVE]: {
    displayName: 'App Live',
    color: 'emerald',
    progressPercent: 100,
    step: 7,
    description: 'App available in store'
  }
};

/**
 * Helper function to get style classes based on status
 */
export const getStatusClasses = (status) => {
  const info = AppStatusInfo[status] || AppStatusInfo[AppStatus.AWAITING_UPLOAD];
  
  const colorMap = {
    'gray': 'bg-gray-500 text-gray-100',
    'blue': 'bg-blue-500 text-blue-100',
    'purple': 'bg-purple-500 text-purple-100',
    'orange': 'bg-orange-500 text-orange-100',
    'amber': 'bg-amber-500 text-amber-100',
    'green': 'bg-green-500 text-green-100',
    'emerald': 'bg-emerald-500 text-emerald-100'
  };
  
  return {
    badge: colorMap[info.color] || colorMap.gray,
    progressBar: `bg-${info.color}-500`,
    text: `text-${info.color}-500`
  };
}; 